export default __webpack_public_path__ + "static/media/Demon Slayer.51764437.mp3";